// removed by extract-text-webpack-plugin
module.exports = {"root":"SearchSwitch__root___1g25X","switch":"SearchSwitch__switch___3OISy","link":"SearchSwitch__link___11ow8","title":"SearchSwitch__title___34LyZ"};


//////////////////
// WEBPACK FOOTER
// ./src/js/Search/Switch/SearchSwitch.scss
// module id = 1364
// module chunks = 1